/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_Sold_OutInputs */

const en_status_sold_out = /** @type {(inputs: Status_Sold_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sold Out`)
};

const es_status_sold_out = /** @type {(inputs: Status_Sold_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agotado`)
};

/**
* | output |
* | --- |
* | "Sold Out" |
*
* @param {Status_Sold_OutInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const status_sold_out = /** @type {((inputs?: Status_Sold_OutInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_Sold_OutInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_status_sold_out(inputs)
	return es_status_sold_out(inputs)
});